module.exports = __webpack_public_path__ + "static/media/slide3-sk.dde56e9c.webp";